import type { Metadata } from 'next';
import { Playfair_Display, Source_Serif_4, IBM_Plex_Sans } from 'next/font/google';
import './globals.css';
import UtilityBar from '@/components/layout/UtilityBar';
import SiteHeader from '@/components/layout/SiteHeader';
import PrimaryNav from '@/components/layout/PrimaryNav';
import BreakingStrip from '@/components/layout/BreakingStrip';
import Footer from '@/components/layout/Footer';

const playfair = Playfair_Display({
  subsets: ['latin'],
  variable: '--font-display',
  display: 'swap',
});

const sourceSerif = Source_Serif_4({
  subsets: ['latin'],
  variable: '--font-body',
  display: 'swap',
});

const ibmPlex = IBM_Plex_Sans({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
  variable: '--font-ui',
  display: 'swap',
});

export const metadata: Metadata = {
  title: {
    default: 'VERITAS NEWS — Trusted Global Journalism',
    template: '%s | VERITAS NEWS',
  },
  description: 'VERITAS NEWS delivers trusted, independent journalism from around the world. Breaking news, analysis, opinion, video and live coverage.',
  keywords: ['news', 'world news', 'breaking news', 'journalism', 'analysis', 'politics', 'business'],
};

import { getHomeData } from '@/lib/api';

export default async function RootLayout({ children }: { children: React.ReactNode }) {
  const { breaking } = await getHomeData().catch(() => ({ breaking: [] }));

  return (
    <html lang="en" className={`${playfair.variable} ${sourceSerif.variable} ${ibmPlex.variable}`}>
      <body className="bg-white text-[#0D0D0D] antialiased" suppressHydrationWarning>
        <UtilityBar />
        <SiteHeader />
        <PrimaryNav />
        <BreakingStrip stories={breaking} />
        <main>{children}</main>
        <Footer />
      </body>
    </html>
  );
}
